import { useSelector, useDispatch } from "react-redux";
import { isLoggedSelector as loggedBSelector } from "store/bailiff/auth/bailiff_auth.selector";
import { isLoggedSelector as loggedASelector } from "store/user/auth/user_auth.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useLogged = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const loggedA = useSelector(loggedASelector);
  const loggedB = useSelector(loggedBSelector);
  const logged = loggedA && loggedB;

  console.log({ loggedA, loggedB });
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { logged };
};
